export const passwordValidation = () => {
    return {
        restrict: 'A',
        require: "ngModel",
        scope: {
        },
        link: function(scope, element, attributes, mCtrl) {
            function myValidation(value) {
                let re = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}/;
                mCtrl.$setValidity('validation', re.test(value));
                return value;
            }
            mCtrl.$parsers.push(myValidation);
        }
    };
};


// WEBPACK FOOTER //
// ./src/app/directive/passwordValidation.ts